export default __webpack_public_path__ + "media/images/icon_developers-f6f6af71d10e27655bdc436afa1be175.png";